import Logo from "@/components/Logo";
import { DASHBOARD_URL } from "@/lib/links";

const links = [
  { href: "#product", label: "Product" },
  { href: "#workflow", label: "Workflow" },
  { href: "#leaders", label: "For leaders" },
  { href: "#focus", label: "Where we focus" },
];

export default function Nav() {
  return (
    <>
      <div className="announce" data-testid="announce-bar">
        <span className="dot">●</span> Live today in real estate. Built for sales teams.
      </div>
      <header className="nav" data-testid="site-nav">
        <div className="wrap nav-inner">
          <a className="logo logo-link" href="#top" data-testid="nav-logo" aria-label="ThinkWire home">
            <Logo size={22} />
          </a>
          <nav className="nav-links">
            {links.map((l) => (
              <a key={l.href} href={l.href} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                {l.label}
              </a>
            ))}
          </nav>
          <div className="nav-actions">
            <a className="btn" href="#product" data-testid="nav-secondary-cta">
              See the product
            </a>
            <a
              className="btn btn-dark"
              href={DASHBOARD_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-cta-button"
            >
              Get started
            </a>
          </div>
        </div>
      </header>
    </>
  );
}
